import React from 'react';

export type MilestoneStatus = 'pending' | 'in_progress' | 'completed' | 'delayed';

interface MilestoneStatusBadgeProps {
  status: MilestoneStatus;
  className?: string;
}

const MilestoneStatusBadge: React.FC<MilestoneStatusBadgeProps> = ({ status, className = '' }) => {
  const getStatusColor = (status: MilestoneStatus) => {
    switch (status) {
      case 'completed':
        return 'bg-[var(--color-success-100)] text-[var(--color-success-800)]';
      case 'in_progress':
        return 'bg-[var(--color-brand-100)] text-[var(--color-brand-800)]';
      case 'delayed':
        return 'bg-[var(--color-error-100)] text-[var(--color-error-800)]';
      default:
        return 'bg-[var(--color-neutral-100)] text-[var(--color-neutral-800)]';
    }
  };

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(status)} ${className}`}
    >
      {status.replace('_', ' ').toUpperCase()}
    </span>
  );
};

export default MilestoneStatusBadge;

